module.exports = __webpack_public_path__ + "static/excluding4-1c2af3c01000dd71d2b0bbc66587169b.png";